const d = new Date();

const BrandIconsStyle = {
    divStyle: "w-full flex flex-row justify-center items-center",
    aStyle: "transition ease-in-out hover:-translate-y-1 hover:scale-110 duration-300",
    spanStyle: "flex justify-center items-center mx-2 rounded-full bg-white w-8 h-8 text-black text-lg"
}

const Projects = [
    {
        id: 1,
        title: 'tookoo-dil',
        description: 'Proyek membuat Rest API untuk pengembangan Online Shop.',
        env: 'PHP, REST API, PostgreeSQL',
        framework: 'Laravel',
        repoUrl: "https://github.com/bagussona/tookoo_dil",
        demoUrl: "https://documenter.getpostman.com/view/14126071/TzY4hG5d",
        created_at: d.setFullYear(2021, 3, 25),
        updated_at: ''
    },
    {
        id: 2,
        title: 'Bank Tukar Sampah - BTS ID',
        description: 'BTS ID adalah aplikasi pelayanan masyarakat dalam penanganan sampah dan menukar sampah yang bisa di daur ulang dengan uang sesuai berat yang terkumpul',
        env: 'PHP, JavaScript, REST API, PostgreeSQL',
        framework: 'Laravel, ReactJs, Tailwind CSS',
        repoUrl: "https://github.com/bagussona/e-Trashing",
        demoUrl: "https://documenter.getpostman.com/view/14126071/TzeWG8HK",
        created_at: d.setFullYear(2021, 5, 25),
        updated_at: ''
    },
    {
        id: 3,
        title: 'Waroeng Jajanan',
        description: 'Online shop penjualan jajanan ringan untuk kantin pondok.',
        env: 'PHP, JavaScript, PostgreeSQL',
        framework: 'Laravel, Blade, Bootstrap4',
        repoUrl: "https://github.com/bagussona/waroeng_jajanan",
        demoUrl: "https://waroeng-jajanan.herokuapp.com/",
        created_at: d.setFullYear(2021, 6, 25),
        updated_at: ''
    },
    {
        id: 4,
        title: 'Simple Management POS - SIMP',
        description: 'SIMP adalah aplikasi point of sales untuk pencatatan penjualan kasir. Simp juga bisa untuk pencatatan keluar masuk barang, dan membuat laporan serta cek log aktifitas.',
        env: 'PHP, JavaScript, REST API, PostgreeSQL',
        framework: 'Laravel, Blade, Bootstrap4',
        repoUrl: "https://github.com/bagussona/simp",
        demoUrl: "http://sistempointofsales.herokuapp.com/login",
        created_at: d.setFullYear(2021, 8, 1),
        updated_at: ''
    },
    {
        id: 5,
        title: 'Lavender Prestisa',
        description: 'Adalah webapp point of sales tempat saya magang di Prestisa.',
        env: 'PHP, JavaScript, REST API, Mongo DB',
        framework: 'Laravel, Angular JS',
        repoUrl: "",
        demoUrl: "https://lavender.prestisa.id/login",
        created_at: d.setFullYear(2021, 10, 25),
        updated_at: ''
    },
    {
        id: 6,
        title: 'Radeeya SCARF',
        description: 'Online shop penjualan scarf brand lokal desain original.',
        env: 'PHP, JavaScript, PostgreeSQL',
        framework: 'Laravel, Livewire, Bootstrap4',
        repoUrl: "https://github.com/bagussona/radeeya_scarf",
        demoUrl: "https://radeeya-scarf.herokuapp.com/",
        created_at: d.setFullYear(2021, 11, 25),
        updated_at: ''
    },
    {
        id: 7,
        title: 'bagussona.github.io',
        description: 'My Online CV.',
        env: 'JavaScript',
        framework: 'ReactJs, Tailwind CSS',
        repoUrl: "https://github.com/bagussona/bagussona.github.io",
        demoUrl: "https://bagussona.github.io/",
        created_at: d.setFullYear(2022, 0, 1),
        updated_at: ''
    },
    {
        id: 8,
        title: 'SIP Mutif',
        description: 'Sistem Informasi Pegawai kantor Mutif, impor dan ekspor data absensi dari mesin fingerprint. Digunakan juga untuk pengajuan izin/ sakit/ cuti secara online, serta berbagi lokasi terkini untuk absensi di luar kantor',
        env: 'PHP, JavaScript, Pusher, REST API',
        framework: 'Laravel',
        repoUrl: "https://github.com/bagussona/sipMutif",
        demoUrl: "https://sip.itmutif.my.id/",
        created_at: d.setFullYear(2022, 2, 25),
        updated_at: ''
    },
    {
        id: 9,
        title: 'Indonesian Territory [Forked Project]',
        description: 'API Statis wilayah Indonesia, Mulai dari Provinsi, Kabupaten, Kecamatan, sampai Daerah!',
        env: 'JavaScript, PHP, Static API, JSON',
        framework: '#',
        repoUrl: "https://github.com/bagussona/api-wilayah-indonesia",
        demoUrl: "https://bagussona.github.io/api-wilayah-indonesia/",
        created_at: d.setFullYear(2022, 2, 25),
        updated_at: ''
    },
    {
        id: 10,
        title: 'Panel Admin Taking-PO',
        description: 'Panel admin untuk administrasi kolektif hasil pre-order yang dilakukan agen dan manajemen inputproduk untuk melakukan transaksi pre-order.Terdapat banyak fitur menarik yang disiapkanuntuk panel admin ini.',
        env: 'PHP',
        framework: 'Laravel',
        repoUrl: "https://github.com/bagussona/po-mutif",
        demoUrl: "https://atpo.itmutif.my.id/login",
        created_at: d.setFullYear(2022, 5, 25),
        updated_at: ''
    },
    {
        id: 11,
        title: 'bagussona-blog',
        description: 'Halaman blog untuk bagussona, dibuat menggunakan hexo framework dan di hosting di gh-pages.',
        env: 'EJS, MD, YAML',
        framework: 'hexo',
        repoUrl: "https://github.com/bagussona/blog",
        demoUrl: "https://bagussona.github.io/blog/",
        created_at: d.setFullYear(2022, 7, 25),
        updated_at: ''
    },
];

const exportedStyle = { BrandIconsStyle, Projects }

export default exportedStyle;